function Pentagon(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M240 11.8 0 186.1l91.7 282.2h296.6L480 186.1 240 11.8z"></path></svg>
    )
}

export default Pentagon